import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PluckingChartReport } from './Pages/Report';

export const PluckingChartReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PluckingChartReport} />
    </Fragment>
)